import { Button, ButtonGroup, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SubSectionSeparator from "../SubSectionSeparator";

const AboutChildStep = ({ ctx }) => {
  const { formData, handleChange } = ctx;

  return (
    <>
      <SubSectionSeparator title="visual_media_consent" />
      <Row>
        <Col md={12}>
          <Form.Group className="mb-4">
            <ButtonGroup className="me-3 ms-0">
              <Button
                size="sm"
                name="pic_nursery"
                onClick={handleChange}
                value="1"
                variant={formData.pic_nursery == 1 ? "secondary" : "light"}
              >
                <FormattedMessage id="yes" />
              </Button>
              <Button
                size="sm"
                name="pic_nursery"
                onClick={handleChange}
                value="0"
                variant={formData.pic_nursery == 0 ? "secondary" : "light"}
              >
                <FormattedMessage id="no" />
              </Button>
            </ButtonGroup>
            <Form.Label>
              <FormattedMessage id="social_media_website" />
            </Form.Label>
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group className="mb-4">
            <ButtonGroup className="me-3 ms-0">
              <Button
                size="sm"
                name="pic_media"
                onClick={handleChange}
                value="1"
                variant={formData.pic_media == 1 ? "secondary" : "light"}
              >
                <FormattedMessage id="yes" />
              </Button>
              <Button
                size="sm"
                name="pic_media"
                onClick={handleChange}
                value="0"
                variant={formData.pic_media == 0 ? "secondary" : "light"}
              >
                <FormattedMessage id="no" />
              </Button>
            </ButtonGroup>
            <Form.Label>
              <FormattedMessage id="advertising" />
            </Form.Label>
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group className="mb-4">
            <ButtonGroup className="me-3 ms-0">
              <Button
                size="sm"
                name="pic_social"
                onClick={handleChange}
                value="1"
                variant={formData.pic_social == 1 ? "secondary" : "light"}
              >
                <FormattedMessage id="yes" />
              </Button>
              <Button
                size="sm"
                name="pic_social"
                onClick={handleChange}
                value="0"
                variant={formData.pic_social == 0 ? "secondary" : "light"}
              >
                <FormattedMessage id="no" />
              </Button>
            </ButtonGroup>
            <Form.Label>
              <FormattedMessage id="printing" />
            </Form.Label>
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group className="mb-4">
            <ButtonGroup className="me-3 ms-0">
              <Button
                size="sm"
                name="take_pictures"
                onClick={handleChange}
                value="1"
                variant={formData.take_pictures == 1 ? "secondary" : "light"}
              >
                <FormattedMessage id="yes" />
              </Button>
              <Button
                size="sm"
                name="take_pictures"
                onClick={handleChange}
                value="0"
                variant={formData.take_pictures == 0 ? "secondary" : "light"}
              >
                <FormattedMessage id="no" />
              </Button>
            </ButtonGroup>
            <Form.Label>
              <FormattedMessage id="educore_app" />
            </Form.Label>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default AboutChildStep;
